export type OfflineState = 'checking' | 'ready' | 'missing' | 'preparing' | 'unavailable' | 'bundled';

/** Checks the controlling worker's cache, without fetching files or changing saved data. */
export async function offlineReadiness(build: string, native = false): Promise<OfflineState> {
  if (native) return 'bundled';
  if (!isSecureContext || !('serviceWorker' in navigator)) return 'unavailable';
  const worker = navigator.serviceWorker.controller;
  if (!worker) {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      return registration?.installing || registration?.waiting || registration?.active ? 'preparing' : 'missing';
    } catch { return 'unavailable'; }
  }
  return new Promise(resolve => {
    const channel = new MessageChannel();
    const finish = (state: OfflineState) => {
      clearTimeout(timer); channel.port1.close(); channel.port2.close(); resolve(state);
    };
    const timer = setTimeout(() => finish('unavailable'), 5000);
    channel.port1.onmessage = event => {
      const result = event.data;
      if (result?.type !== 'WORDHULI_OFFLINE_STATUS' || result.build !== build) { finish('unavailable'); return; }
      finish(result.ready === true && Number.isInteger(result.total) && result.total > 0 && result.checked === result.total ? 'ready' : 'missing');
    };
    try { worker.postMessage({ type: 'WORDHULI_OFFLINE_STATUS' }, [channel.port2]); }
    catch { finish('unavailable'); }
  });
}
